import { gql } from "@apollo/client";

export const GET_PROGRAM_TYPES = gql`
query GetProgramTypes{
    programTypes
    {
        idTipoPrograma
        nombre
        subTipoPrograma {
            idSubTipoPrograma
            nombre
        }
    }
}`;